import React from 'react';

const Portfolio = () => {
    return (
        <div className='text-center'>
            <h1 className='font-bold text-2xl text-center my-16'>My Portfolio</h1>
            <p>Name:Shakila Khatun Shely</p>
            <p>E-mail:shely.ece.25@gmail.com</p>
            <p>Educational Background: Studying B.Sc. Engineering at Khulna University Of Engineering And Technlogy
            </p>
            <p><span className='font-medium'>List of Skills</span>:
                <ul>
                    <li>OOP</li>
                    <li>Data Structure and Algoritm</li>
                    <li>HTML, CSS, JavaScript,Tailwind,Bootstrap</li>
                    <li>Nodejs,mongoDb</li>
                </ul>
            </p>
        </div>
    );
};

export default Portfolio;